import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getUsers } from 'modules/_common/api';

export const useQueryEmployees = ({ enabled }: { enabled?: boolean }) => {
  const { data, isError, isLoading, refetch, isFetching } = useQuery(
    QUERY_KEYS.RENTALS_EMPLOYEES,
    getUsers,
    {
      staleTime: 5 * 60 * 1000, //5 minutes
      enabled,
    },
  );

  return {
    data: data,
    isError,
    isLoading,
    refetch,
    isFetching,
  };
};
